import React, { useRef, useState } from 'react'
import {
    PageTitleText,FormContainer,PageLinkText,AuthBgContainer,FlexContainer
} from './reset_password.style';

import {
    AppInputField,InputFieldTitleText,AppInputFieldBtn
} from '../../../widget/styledComponents/input_field.style'
import { gql, useMutation } from '@apollo/client';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { toaster } from 'evergreen-ui';
import { PageLinkTextNoLink } from '../sign_in/sign_in.style';
import {useHistory } from 'react-router-dom';


export const SET_NEW_PASSWORD = gql`
mutation FacilityManager_resetPassword($token: String!, $password: String!) {
  facilityManager_resetPassword(token: $token, password: $password) {
    code
    success
    error
    token
  }
}
`;


function ResetPasswordWidget() {
const { id } = useParams();
const [setPassword, { loading}] = useMutation(SET_NEW_PASSWORD);
const [showPass,setShowPass] = useState(false)
const history = useHistory()


const handleSubmit = (e)=>{
e.preventDefault();
setPassword({
  variables: { 
    token: id,
    password:passwordRef.current.value
  },
})
.then((response) => {
  if(response.data['facilityManager_resetPassword']['code']==='200'){
    passwordRef.current.value=''
    toaster.success("New Password Set")
    history.push(`/`);
  }
})
.catch((error) => {
  toaster.danger(error.message)
});

};

const passwordRef = useRef(null);

  return (
    <div className='row'>
        <AuthBgContainer className="col s12 m6 l6 hide-on-med-and-down"></AuthBgContainer>
        <div className='col s12 m6 l6 '>
            <div className='mt-100'></div>
            <form onSubmit={handleSubmit}>
            <FormContainer >
                <PageTitleText>
                    Reset Password
                    {/* {id} */}
                </PageTitleText>
                <br/><br/>
                
                <InputFieldTitleText>
                    Enter Password
                </InputFieldTitleText>
                <AppInputField
                    type= {showPass?'text':'password' }
                    // type='text'
                    ref={passwordRef}
                /> 
                <div className='col s12 right'>
                    <PageLinkTextNoLink className='right' style={{
                    color:"var(--black, #4F46E5) !important",fontSize:"12px",
                    }} onClick={()=>setShowPass(!showPass)}>{showPass?'Hide':'Show'}</PageLinkTextNoLink >
                </div>
               
                <AppInputFieldBtn className="mt-50"  disabled={loading}>
                    Submit
                </AppInputFieldBtn>
                <FlexContainer>
                    Already have an account?
                    <PageLinkText className='right' style={{
                        color:"var(--black, #4F46E5) !important",fontSize:"18px",
                    }} to="/" > Log in</PageLinkText>
                </FlexContainer>
                

            </FormContainer>
            </form>

        </div>
    </div>
  )
}

export default ResetPasswordWidget